import React from 'react';

import EventUsersBadge from 'legacy/common/components/wysiwyg-form/EventUsersBadge';
import { useTranslation } from 'react-i18next';

const GuestlistBadges = ({ onClick, guestsPreview, totalGuests }) => {
  const { t } = useTranslation(['events']);

  return (
    <div className="mt-6">
      <EventUsersBadge
        additionalGuests={Math.max(totalGuests - guestsPreview.length, 0)}
        onClick={onClick}
        title={t('events:eventDetails.guestList')}
        data={guestsPreview}
        secondaryDefaultText={
          totalGuests === 0
            ? t('events:eventDetails.beTheFirstToRSVP')
            : t('events:eventDetails.total', {
                count: totalGuests
              })
        }
      />
    </div>
  );
};

export default GuestlistBadges;
